import { render, staticRenderFns } from "./AddReportHome.vue?vue&type=template&id=06ad5832&"
import script from "./AddReportHome.vue?vue&type=script&lang=js&"
export * from "./AddReportHome.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports